/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Select,
  MenuItem,
  SelectChangeEvent,
  Box,
  IconButton,
  Tooltip,
} from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useLazyGetPortfolioQuery } from "../../services/users";
import useTranslation from "../../hooks/traslation";
import RejectReasonModal from "../../Modals/rejectReason";
import CommissionOfferModal from "../../Modals/commissionOffer";
import { SKILLS, INDUSTRY } from "../../utils/enums";
import { workerData } from "worker_threads";

interface PortfolioItem {
  _id: string;
  image: string;
  title: string;
  description: string;
  duration: string;
  industry: string;
  skills: string[];
}

const FreelancerPortfolio = ({
  freelancerId,
  debouncedSearchTerm,
}: // setDebouncedSearchTerm,
{
  freelancerId: string;
  debouncedSearchTerm: string;
  // setDebouncedSearchTerm: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const navigate = useNavigate();
  const translation = useTranslation();
  const [getPortfolio] = useLazyGetPortfolioQuery();
  const [rows, setRows] = useState<PortfolioItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const handlePageChange = (event: any, newPage: number) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);

    const params = new URLSearchParams(window.location.search);
    params.set("page", updatedPage.toString());

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.pushState({}, "", newUrl);
  };

  const fetchPortfolio = async () => {
    setIsLoading(true);
    try {
      const response = await getPortfolio({
        id: freelancerId,
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.statusCode === 200) {
        setRows(response?.data?.list || []);
        setCount(response?.data?.totalCount);
      }
    } catch (error) {
      console.error("Error fetching portfolio:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (freelancerId) {
      fetchPortfolio();
    }
  }, [freelancerId, debouncedSearchTerm]);

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 220,
      field: "maintenance",
      headerName: "Freelancer Portfolio Detail",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-freelancer/portfolio-detail/${row?._id}`)
            }
          >
            <p>
              <b>{row?.title || "-"}</b>
              <span>{row?.description || ""}</span>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "duration",
      headerName: "Project Duration",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>{row?.duration ? `${row.duration} months` : "-"}</strong>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "industry",
      headerName: "Industry",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>
              {Array.isArray(row?.industry)
                ? row.industry
                    .map(
                      (industryId) =>
                        INDUSTRY[industryId as keyof typeof INDUSTRY]
                    )
                    .filter(Boolean)
                    .join(", ")
                : "-"}
            </strong>
          </p>
        );
      },
    },
    {
      minWidth: 150,
      field: "skills",
      headerName: "Skills Used",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            <strong>
              {Array.isArray(row?.skills)
                ? row.skills
                    .map((skillId) =>
                      Object.keys(SKILLS).find(
                        (key) =>
                          SKILLS[key as keyof typeof SKILLS] === Number(skillId)
                      )
                    )
                    .join(", ")
                : "-"}
            </strong>
          </p>
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: translation.globals.actions,
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <Tooltip title="View">
                <IconButton
                  onClick={() =>
                    navigate(`/manage-freelancer/portfolio-detail/${row?._id}`)
                  }
                >
                  <img src="/static/images/eye_icon.svg" alt="View" />
                </IconButton>
              </Tooltip>
            </Box>

            <Box>
              <Tooltip title="Edit">
                <IconButton
                  onClick={() =>
                    navigate(
                      `/manage-freelancer/portfolio/edit/${freelancerId}/${row?._id}`
                    )
                  }
                >
                  <img src="/static/images/edit2_icon.svg" alt="" />
                </IconButton>
              </Tooltip>
            </Box>
          </div>
        );
      },
    },
  ];

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleCloseModal1 = () => {
    setOpen1(false);
  };

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns}
          rows={rows}
          loading={isLoading}
          page={page}
          count={count}
          onPageChange={handlePageChange}
        />
      </div>

      <CommissionOfferModal
        open={open}
        onClose={handleCloseModal}
        setOpen={setOpen}
      />
      <RejectReasonModal
        open={open1}
        onClose={handleCloseModal1}
        setOpen={setOpen1}
      />
    </>
  );
};

export default FreelancerPortfolio;
